/*
 * Application Color Box
 */

export const COLORS = {
  PRIMARY: "#1363DF",
  SECONDARY: "#06283D",
  DANGER: "#ff0e0e",
  WHITE: "#fff",
  BLACK: "#000",
  DIM_GRAY: "#e1e1e1",
  DIM_DARK_GRAY: "#6e6e6e",
  SAVE_GREEN: "#22b378",
  GRID_ADD_NEW: "#22b378",
  RELOAD_EXPORT: "#e9e9e9",
  RELOAD_EXPORT_TEXT: "#3f3f3f",
  GRID_HEADER: "#f7f7f7",
  GRID_HEADER_TEXT: "#5c6b65",
};
